import { Converter } from '../types/converter';

export const momentOfForceConverter: Converter = {
  id: 'momentOfForce',
  name: 'Moment of Force Converter',
  icon: 'RotateCw',
  categories: ['engineering', 'physics'],
  units: [
    // Base SI unit
    { name: 'Newton meter', symbol: 'N·m', factor: 1 },
    
    // SI derived units
    { name: 'Newton centimeter', symbol: 'N·cm', factor: 0.01 },
    { name: 'Newton millimeter', symbol: 'N·mm', factor: 0.001 },
    { name: 'Kilonewton meter', symbol: 'kN·m', factor: 1000 },
    
    // CGS units
    { name: 'Dyne meter', symbol: 'dyn·m', factor: 1e-5 },
    { name: 'Dyne centimeter', symbol: 'dyn·cm', factor: 1e-7 },
    { name: 'Dyne millimeter', symbol: 'dyn·mm', factor: 1e-8 },
    
    // Gravitational units
    { name: 'Kilogram-force meter', symbol: 'kgf·m', factor: 9.80665 },
    { name: 'Kilogram-force centimeter', symbol: 'kgf·cm', factor: 0.0980665 },
    { name: 'Kilogram-force millimeter', symbol: 'kgf·mm', factor: 0.00980665 },
    { name: 'Gram-force meter', symbol: 'gf·m', factor: 0.00980665 },
    { name: 'Gram-force centimeter', symbol: 'gf·cm', factor: 0.0000980665 },
    { name: 'Gram-force millimeter', symbol: 'gf·mm', factor: 0.00000980665 },
    
    // Imperial/US units
    { name: 'Pound-force foot', symbol: 'lbf·ft', factor: 1.355818 },
    { name: 'Pound-force inch', symbol: 'lbf·in', factor: 0.112984829 },
    { name: 'Ounce-force foot', symbol: 'ozf·ft', factor: 0.084738622 },
    { name: 'Ounce-force inch', symbol: 'ozf·in', factor: 0.007061552 },
    { name: 'Poundal foot', symbol: 'pdl·ft', factor: 0.042140110 },
    { name: 'Poundal inch', symbol: 'pdl·in', factor: 0.003511676 }
  ]
};
